import BRAND_CODES from './brand-codes';
import PRIVACY_BRAND_CONFIG from './privacy';
import PSMS_BRAND_CONFIG from './psms';
import MG_SAFE_BRAND_CONFIG from './mgsafe';
import DSHOP_BRAND_CONFIG from './dshop';
import DSAFE_BRAND_CONFIG from './dsafe';
import PARTYHAT_BRAND_CONFIG from './partyhat';
import PROTECTIV_BRAND_CONFIG from './protectiv';
import PHSAFE_BRAND_CONFIG from './phsafe';
import DEFAULT_BRAND_CONFIG from './default';
import type { BrandConfigType } from './types';

const BRAND_CONFIG: BrandConfigType = {
  [BRAND_CODES.privacyShield]: PRIVACY_BRAND_CONFIG,
  [BRAND_CODES.privacyMedicalShield]: PSMS_BRAND_CONFIG,
  [BRAND_CODES.missGroupSafe]: MG_SAFE_BRAND_CONFIG,
  [BRAND_CODES.domeneShop]: DSHOP_BRAND_CONFIG,
  [BRAND_CODES.domainkeskusSafe]: DSAFE_BRAND_CONFIG,
  [BRAND_CODES.partyhat]: PARTYHAT_BRAND_CONFIG,
  [BRAND_CODES.protectIV]: PROTECTIV_BRAND_CONFIG,
  [BRAND_CODES.phSafe]: PHSAFE_BRAND_CONFIG,
  default: DEFAULT_BRAND_CONFIG,
};

export default BRAND_CONFIG;
